import { ChevronDown, Layers, ListChecks } from "lucide-react";
import { useTran } from "@/hooks";
import { cn } from "@/lib/utils";
import { CategoryBadge, MetricCodeBadge } from "@/components/common";

const OverviewMetricRow = ({
  row,
  isExpanded,
  onToggleDetail,
  formatYearLabel,
  formatFrameworkLabel,
}) => {
  const { t } = useTran();
  const yearLabel = formatYearLabel ? formatYearLabel(row.year) : row.year;
  const frameworkLabel = formatFrameworkLabel
    ? formatFrameworkLabel(row.framework)
    : row.framework;
  const organizationCount =
    row.orgsWithValue ?? row.orgsWithData ?? row.orgsBoth ?? 0;

  return (
    <div className="flex items-center justify-between gap-3 rounded-md border border-border/60 bg-card/95 p-3">
      <div className="flex min-w-0 items-center gap-3">
        <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-primary/10 text-primary">
          <ListChecks className="h-4 w-4" />
        </span>
        <div className="min-w-0">
          <p className="truncate text-sm font-semibold text-foreground">
            {row.title}
          </p>
          <div className="mt-1 flex flex-wrap items-center gap-1.5 text-[11px]">
            <MetricCodeBadge code={row.code} category={row.category} />
            <span className="rounded border border-border/70 bg-muted/40 px-1.5 py-0.5 text-muted-foreground">
              {yearLabel}
            </span>
            <span className="inline-flex items-center gap-1 rounded border border-border/70 bg-muted/40 px-1.5 py-0.5 text-muted-foreground">
              <Layers className="h-3 w-3" />
              {frameworkLabel}
            </span>
            <CategoryBadge category={row.category} />
          </div>
        </div>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <span className="whitespace-nowrap rounded-full border border-border/70 bg-muted/40 px-2.5 py-1 text-xs text-foreground">
          {t("Organizations")}: {organizationCount}
        </span>
        {onToggleDetail && (
          <button
            type="button"
            onClick={onToggleDetail}
            className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted/60 hover:text-foreground"
          >
            {t("View Detail")}
            <ChevronDown
              className={cn(
                "h-4 w-4 transition-transform",
                isExpanded && "rotate-180",
              )}
            />
          </button>
        )}
      </div>
    </div>
  );
};

export default OverviewMetricRow;
